<template>
    <div class="content">
        <div class="main" v-for="(item, index) in ifmExamObj" :key="index">
            <a class="single" :href="item.url">
                <span class="dot"/>
                <span class="title">{{item.title}}</span>
            </a>
            <div class="line"/>
        </div>
        
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'ifmExamObj'
    ]),
    props:{
        list:{
            type:Array,
            default: () => [],
        }
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
.content{
    width: 200px;
    background: #F0F0F0;
    padding: 0 15px;
}
.main{
    width:100%;
    position: relative;
}
.single{
    padding: 12px 0;
    cursor: pointer;
    .dot{
        width:4px;
        height:4px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        background: #235483;
        margin-right: 7px;
    }
    .title{
        font-size: 16px;
        color: #235483;
        letter-spacing: 0.45px;
        line-height: 62px;
        font-weight: 400;
        display: inline-block;
        vertical-align: middle;
    }
}
.line{
    width:100%;
    border-top: 1px dashed #CDCDCD;
}
</style>
